import React, {useEffect, useState} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {Session} from "@supabase/supabase-js";
import {SEO} from "@/components/SEO.tsx";
import {useAuth} from "@/contexts/AuthContext.tsx";

const XCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    /*const [userSession] = useState<Session | null>(() => {
        const cachedSession = localStorage.getItem('session');
        return cachedSession ? JSON.parse(cachedSession) : null;
    });*/
    const {user, session, loading} = useAuth();
    useEffect(() => {
        // URL'den query parametreleri alın
        const codeVerifier = localStorage.getItem("x-verify");
        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get("code");
        const state = queryParams.get("state");

        if (code) {
            // Sunucu tarafındaki token değişim endpoint'inize istekte bulunun.
            // Burada POST isteği örneklenmiştir.
            fetch(`${import.meta.env.VITE_API_URL}/x/callback`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${session.access_token}`,
                },
                body: JSON.stringify({ code, state, codeVerifier }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Token exchange failed");
                    }
                    return response.json();
                })
                .then((data) => {
                    // Elde edilen access token'ı uygun şekilde saklayın
                    // console.log("Access Token:", data.access_token)
                    // İşlem başarılıysa kullanıcıyı başka bir sayfaya yönlendirin
                    navigate("/account");
                })
                .catch((error) => {
                    // console.error("Token exchange error:", error);
                    // Hata durumunda kullanıcıya mesaj gösterebilir veya farklı bir rotaya yönlendirebilirsiniz.
                });
        } else {
            // console.error("Callback URL'de 'code' parametresi bulunamadı.");
        }
        localStorage.removeItem("x-verify");
    }, [location, navigate]);

    return (
        <div>
            <SEO
                title="Redirecting.."
                description="Processing your external login callback. Redirecting you shortly"
                type="website"
                name="blankpoll"
                imageUrl="/blankpoll-banner.jpg"
            />
            <p>Processing your external login callback. Redirecting you shortly..</p>
        </div>
    );
};

export default XCallback;
